import { memoize } from 'proxy-memoize';
import { AppStore } from '../store/appStore';

export const getAppIsClient = memoize((s: AppStore) => s.isClient);
export const getAppIsWeb = memoize((s: AppStore) => s.isWeb);

export const getFnAppSetClient = memoize((s: AppStore) => s.setClient);
export const getFnAppSetWeb = memoize((s: AppStore) => s.setWeb);
